(function (Drupal, once) {

  Drupal.behaviors.lifewatchUpdates = {

    attach: function (context, settings) {
      const updateItems = once('lwUpdates', '.updates', context);
      updateItems.forEach((item)=> {
        getUpdateData().then(pubData => {
          if(pubData !== 0) {
            const formatted = (pubData / 1000).toFixed(3) + " + 66.437";
            item.innerText = formatted;
          }
        });
      });
    }
  };
}(Drupal, once));

const getUpdateData = async function () {
  const base_url = window.location.origin;
  const url = base_url + "/code/aphia.php?p=ajax&a=stats&src=lifewatch";
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    let updates = parseInt(json.spp_accepted.measure);

    return updates;
  } catch (error) {
    console.error(error.message);
    return 0;
  }
};
